import React from "react";
import { SMS_PRIVACY_URL, SMS_TERMS_URL } from "./smsConsent";

const ExternalLink = ({ href }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
    {href}
  </a>
);

// SMS_OPT_IN_TEXT (smsConsent.js) with its links clickable. Shown in My Profile's opt-in popup and in the
// "add a mobile" step after authenticator setup; keep the two in step when the wording changes.
const SmsConsentText = () => (
  <>
    <strong>Superior Loan Servicing:</strong> By selecting this check box and entering your phone number, you
    agree to receive one-time passcodes for your LoanlinQ login and alerts about security changes to your
    account. You also agree to the terms of service (<ExternalLink href={SMS_TERMS_URL} />) and privacy policy
    (<ExternalLink href={SMS_PRIVACY_URL} />). This agreement isn’t a condition of any purchase. Message
    frequency varies. Message and data rates may apply. Reply STOP to opt out; HELP for more information.
  </>
);

export default SmsConsentText;
